import {
    get,
    post,
    put
} from '../configApi'

export async function getRoom(params) {
    return await get(`/room/list/course/admin`, params)
}
export async function getTeacherList(params) {
    return await get(`/account/list/teacher`, params)
}
export async function getTeacherRoomList(params) {
    return await get(`/account/list/room/teacher`, params)
}
export async function insertRoom(body) {
    return await post(`/room/manage/insert/course`, body)
}
export async function updateRoom(body) {
    return await put(`/room/manage/update/course`, body)
}
export async function updateRoomActive(body) {
    return await put(`/room/manage/active/course`, body)
}